/**
 * Sends one `page_view` to Google Analytics. Does nothing on a page without the
 * tag (Development, staging).
 *
 * The React layouts' tag is configured with `send_page_view: false`, so this is
 * the only `page_view` of a navigation. The location and the title are `set`
 * before the event, so that the events gtag sends by itself afterwards
 * (engagement, scroll) carry them as well instead of the browser's own URL and
 * title: in the play app the URL's hash is the connection id, which holds the
 * name of a student who is not signed in.
 *
 * Never pass anything that identifies a person (an email, a name): Google's
 * terms forbid it.
 */
export function sendPageView(pageLocation: string, language: string) {
  const gtag = (window as any).gtag
  if (typeof gtag !== "function") return

  gtag("set", {
    page_location: pageLocation,
    page_title: document.title,
    language,
  })
  gtag("event", "page_view")
}
